import { ArrowBack, Close } from "@material-ui/icons";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import {
  CustomTable,
  PrimaryButton,
  SearchTextInput,
  SecondaryButton,
} from "components";

const ModalTable = ({
  open,
  onClose,
  title,
  page,
  pageSize,
  pageCount,
  handleChangePage,
  handleChangePageSize,
  columnTable,
  dataTable,
  isLoading,
  search,
  searchValue,
  handleSearch,
  searchPlaceholder,
  isHaveAction,
  renderAction,
  handleView,
  deleteConfirmation,
  deleteConfirmationContent,
  deleteConfirmationKey,
  deleteConfirmationTitle,
  handleRestore,
  restoreConfirmation,
  restoreConfirmationContent,
  restoreConfirmationKey,
  restoreConfirmationTitle,
  tooltipDelete,
  tooltipEdit,
  tooltipRestore,
  tooltipView,
  handleEdit,
  handleDelete,
  disabledView,
  disabledEdit,
  disabledDelete,
  disabledRestore,
  pageSizeList,
  onRequestSort,
  sortValue,
  checkboxHeader,
  checked,
  checkedAction,
  color,
  customAction,
  emptyPlaceHolder,
  handleCheckbox,
  handleCheckboxAction,
  isHaveCheckbox,
  rowClick,
  tableSize,
  tooltipCheckbox,
  disabledCheckbox,
  tooltipCheckboxAction,
  disabledCheckboxAction,
  loadingButton,
  handleSubmit,
  buttonLabel,
  handleCancel,
  closeButton,
}) => {
  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      {title && (
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Grid container columnGap={1}>
                {!closeButton && (
                  <Grid item>
                    <IconButton onClick={onClose}>
                      <ArrowBack />
                    </IconButton>
                  </Grid>
                )}
                <Grid item>
                  <Typography fontSize={24} fontWeight={700}>
                    {title}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {closeButton && (
              <Grid item>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </DialogTitle>
      )}
      <DialogContent>
        {search && (
          <SearchTextInput
            fullWidth
            placeholder={searchPlaceholder || "Search"}
            value={searchValue}
            onChange={handleSearch}
          />
        )}
        <Box mt={search && "24px"}>
          <CustomTable
            columnTable={columnTable}
            data={dataTable}
            page={page}
            pageSize={pageSize}
            pageCount={pageCount}
            handleChangePage={handleChangePage}
            handleChangePageSize={handleChangePageSize}
            isLoading={isLoading}
            maxHeight={400}
            skeletonHeight={474}
            isHaveAction={isHaveAction}
            renderAction={renderAction}
            handleView={handleView}
            deleteConfirmation={deleteConfirmation}
            deleteConfirmationContent={deleteConfirmationContent}
            deleteConfirmationKey={deleteConfirmationKey}
            deleteConfirmationTitle={deleteConfirmationTitle}
            handleRestore={handleRestore}
            restoreConfirmation={restoreConfirmation}
            restoreConfirmationContent={restoreConfirmationContent}
            restoreConfirmationKey={restoreConfirmationKey}
            restoreConfirmationTitle={restoreConfirmationTitle}
            tooltipDelete={tooltipDelete}
            tooltipEdit={tooltipEdit}
            tooltipRestore={tooltipRestore}
            tooltipView={tooltipView}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            disabledView={disabledView}
            disabledEdit={disabledEdit}
            disabledDelete={disabledDelete}
            disabledRestore={disabledRestore}
            pageSizeList={pageSizeList}
            onRequestSort={onRequestSort}
            sortValue={sortValue}
            checkboxHeader={checkboxHeader}
            checked={checked}
            checkedAction={checkedAction}
            color={color}
            customAction={customAction}
            emptyPlaceHolder={emptyPlaceHolder}
            handleCheckbox={handleCheckbox}
            handleCheckboxAction={handleCheckboxAction}
            isHaveCheckbox={isHaveCheckbox}
            rowClick={rowClick}
            tableSize={tableSize}
            tooltipCheckbox={tooltipCheckbox}
            disabledCheckbox={disabledCheckbox}
            tooltipCheckboxAction={tooltipCheckboxAction}
            disabledCheckboxAction={disabledCheckboxAction}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        {handleCancel && (
          <SecondaryButton
            label="Cancel"
            onClick={onClose}
            disabled={loadingButton}
          />
        )}
        {handleSubmit && (
          <PrimaryButton
            label={
              buttonLabel ? buttonLabel : loadingButton ? "Saving" : "Save"
            }
            disabled={loadingButton}
            loading={loadingButton}
            onClick={handleSubmit}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ModalTable;
